import { useDispatch, useSelector } from "react-redux";
import Cart from "./Cart";
import { modalActions } from "../../storage/modals";
import TopDonatorsModal from "./Donators";
import AddToCart from "./AddToCart";
import MoneyToCart from "./MoneyToCart";
import Promocodes from "./Promocodes";
import Voting from "./Voting";

const Modal = (props) => {
  const modalStates = useSelector(state => state.modals);
  const dispatch = useDispatch();

  const closeModals = () => {
    dispatch(modalActions.hideAllModals());
  }

  return (
    <div className="modal">
      <div className="modal-bg" onClick={closeModals}></div>
      <div className="modal-wrapper">
        {modalStates.cart && <Cart closeHandler={closeModals} />}
        {modalStates.donators && <TopDonatorsModal closeHandler={closeModals} />}
        {modalStates.addToCart && <AddToCart closeHandler={closeModals} />}
        {modalStates.moneyCart.show && <MoneyToCart closeHandler={closeModals} />}
        {modalStates.promocodes.show && <Promocodes closeHandler={closeModals} />}
        {modalStates.voting.show && <Voting closeHandler={closeModals} />}
      </div>
    </div>
  );
};

export default Modal;
